import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'SPHINXFI',
  description: 'SPHINXFI',
  image: 'https://ukadoge.com/images/logo.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  return {
    title: `${t('Exchange')} | ${t('SPHINXFI')}`,
  }
}
